import { API_URL } from "../api/apiConfig";

export const KAKAOREDRIECTURL = `${API_URL}/kakaoLogin`;

export const KAKAOCLIENTID = process.env.REACT_APP_KAKAO_CLIENT_ID;
export const KAKAOSTATE = process.env.REACT_APP_KAKAO_STATE;
export const KAKAOSCOPES = process.env.REACT_APP_KAKAO_SCOPES;
export const KAKAONONCE = process.env.REACT_APP_KAKAO_NONCE;
